import React, {Component} from 'react';
import './CentralTimesItem.css';
import config from '../../../config';

class CentralTimesItem extends Component {
  constructor(props){
    super(props);
  }

  render() {
    const {data:{old_id, alias, title}} = this.props;
    const dlLink = encodeURI(`${config.DL_URL}/joomla/central-times?download=${old_id}:${alias}`)
    return (
      <div className="centralTimesItem ui raised segment">
        <div>
          <strong>{title}</strong>
        </div>
        <div className="downloadButtonBlock">

          {/*<a href={`/phocadownload/${data.filename}`} target="_blank">*/}
              <a href={dlLink} target="_blank">
              <button class="ui primary button">Download</button>
          </a>
        </div>
      </div>
    );
  }
}

export default CentralTimesItem;
